import React, { useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  List,
  Link as ExternalLink,
  ListItem,
  Typography
} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { makeStyles } from "@material-ui/core/styles";

type APIProductInfoProps = {
  userEmail: string;
  title: string;
  body: string;
  link: string;
  list: string[];
  priceData: string;
  priceCalls: string;
};

const useStyles = makeStyles(theme => ({
  checkIcon: {
    color: "#80FF80",
    float: "left",
    marginRight: "5px",
    transform: "translate(0, -5px)"
  },
  divider: {
    background: theme.palette.background.paper,
    height: "3px",
    marginBottom: "12px"
  }
}));

const APIProductInfo: React.FC<APIProductInfoProps> = ({
  userEmail,
  title,
  body,
  link,
  list,
  priceData,
  priceCalls
}: APIProductInfoProps) => {
  const classes = useStyles();
  const [successState, setSuccessState] = useState(false);

  const handleClick = (product: string) => {
    fetch(`https://hooks.zapier.com/hooks/catch/4429888/o9397fm/`, {
      method: "POST",
      body: JSON.stringify({ email: userEmail, product: "" ? title : product })
    });
    setSuccessState(true);
    setTimeout(function() {
      setSuccessState(false);
    }, 4000);
  };

  return (
    <>
      {successState && (
        <Card
          style={{
            textAlign: "center"
          }}
        >
          <CardContent>
            <Typography variant="subtitle2">
              Great! We'll be in Touch!
              <CheckCircleIcon className={classes.checkIcon} />
            </Typography>
          </CardContent>
        </Card>
      )}
      <Card>
        <CardContent>
          <Typography variant="h4">{title}</Typography>
          <Typography variant="subtitle2">{body}</Typography>
          <List dense>
            {list.map((value, index) => {
              const labelId = `description-list-label-${index}`;
              return (
                <ListItem key={labelId}>
                  <Typography variant="subtitle1">
                    <CheckIcon className={classes.checkIcon} />
                    {value}
                  </Typography>
                </ListItem>
              );
            })}
          </List>
          <Divider classes={{ root: classes.divider }} />
          {
            // Uncomment this if we decide to advertise pricing data again
            /* <Typography variant="subtitle2">{priceData}</Typography>
          <Typography variant="subtitle2">{priceCalls}</Typography> */
          }

          <Grid item spacing={1} container>
            <Grid item>
              <Button variant="contained" onClick={e => handleClick("Custom")}>
                Talk to Sales
              </Button>
            </Grid>
            <Grid item>
              <ExternalLink
                href={`https://docs.sofarocean.com/${link}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button variant="outlined">Learn More</Button>
              </ExternalLink>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {
        // Uncomment this if we decide to advertise pricing data again
        /* <Card
        style={{
          textAlign: "center"
        }}
      >
        <CardContent>
          <Typography variant="subtitle2">
            Does your app or product sell weather data or do you need something
            custom?
          </Typography>

          <Button variant="contained" onClick={e => handleClick("")}>
            Talk to Sales
          </Button>
        </CardContent>
      </Card> */
      }
    </>
  );
};

export default APIProductInfo;
